export const SAFE_AREA_INSET_LEFT = "env(safe-area-inset-left)"
export const SAFE_AREA_INSET_RIGHT = "env(safe-area-inset-right)"
export const SAFE_AREA_INSET_TOP = "env(safe-area-inset-top)"
